<template>
  <div>
    <el-table @sort-change="changeTableSort" :data="tableData" highlight-current-row border style="width: 100%; margin-top: 39px; margin-bottom: 20px" :empty-text="$t('general.empty_data')">
      <el-table-column sortable="custom" prop="employee_id" :label="$t('general.employee_id')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_id }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empList.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column sortable="custom" prop="employee_type" :label="$t('empList.title')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_type }}</span>
        </template>
      </el-table-column>

      <el-table-column sortable="custom" prop="birthday" :label="$t('empList.birthday')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.birthday }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="500px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-document" @click="handleRaiseDeclaration(scope.$index, scope.row)">
            給与所得者の扶養控除等（異動）申告</el-button>
          <el-button size="mini" type="success" icon="el-icon-user" @click="jump('/empList')">
            従業員情報変更</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleSortChange">
      </el-pagination>
    </div>

    <!-- 給与所得者の扶養控除等（異動）申告編集 -->
    <el-dialog title="給与所得者の扶養控除等（異動）申告編集" :visible.sync="dialogEdit" width="86%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="210px" class="demo-ruleForm" size="medium" style="margin-left:20px" :label-position="labelPosition">
        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item label="申告書年分" prop="year">
                <el-select v-model="ruleForm.year" size="mini" placeholder="選択" style="margin-left:10px;width: 200px" clearable>
                  <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('empPDF.name')" prop="name">
                <el-input prefix-icon="el-icon-info" v-model="empListForm.name" size="mini" style="margin-left:10px;width: 200px" :placeholder="$t('empPDF.name')" readonly></el-input>
              </el-form-item>

              <el-form-item label="生年月日" prop="name">
                <el-date-picker prefix-icon="el-icon-info" v-model="empListForm.birthday" size="mini" type="date" style="margin-left:10px;width: 200px" placeholder="生年月日" readonly="readonly">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="世帯主の氏名" prop="name">
                <el-input v-model="ruleForm.host_name" size="mini" style="margin-left:10px;width: 200px"></el-input>
              </el-form-item>

              <el-form-item label="配偶者の有無" prop="spouse_is">
                <el-select v-model="ruleForm.spouse_is" style="margin-left: 10px; width: 200px" :placeholder="$t('general.select')" size="mini">
                  <el-option v-for="item in spouse" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <el-form-item label="記載例" prop="name">
                <el-link style="margin-left:10px;" type="primary" class="el-icon-info" :underline="false" href="https://www.nta.go.jp/taxes/tetsuzuki/shinsei/annai/gensen/pdf/r3bun_02.pdf" target="_blank">控除申告書の記載例はこちら</el-link>
              </el-form-item>

              <el-form-item :label="$t('empPDF.name_frgn')" prop="name_frgn">
                <el-input prefix-icon="el-icon-info" v-model="empListForm.name_frgn" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.name_frgn')" readonly></el-input>
              </el-form-item>

              <el-form-item label="個人番号" prop="name">
                <el-input prefix-icon="el-icon-info" v-model="empListForm.mynum" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
              </el-form-item>

              <el-form-item label="あなたとの続柄" prop="name">
                <el-input v-model="ruleForm.relation" size="mini" style="margin-left:10px;width: 185px"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div>
              <el-form-item :label="$t('empPDF.address')" prop="address">
                <el-input :value="empListForm.address" prefix-icon="el-icon-info" size="mini" style="margin-left:10px;width: 825px" :placeholder="$t('empPDF.address')" readonly></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateRaise('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}</el-button>
        <el-button style="width:120px" @click="raise_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!-- 給与所得者の扶養控除等（異動）申告新規 -->
    <el-dialog title="給与所得者の扶養控除等（異動）申告新規" :visible.sync="dialogAdd" width="86%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="210px" class="demo-ruleForm" size="medium" style="margin-left:20px" :label-position="labelPosition">
        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item label="申告書年分" prop="year">
                <el-select v-model="ruleForm.year" size="mini" placeholder="選択" style="margin-left:10px;width: 200px" clearable>
                  <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('empPDF.name')" prop="name">
                <el-input prefix-icon="el-icon-info" v-model="empListForm.name" size="mini" style="margin-left:10px;width: 200px" :placeholder="$t('empPDF.name')" readonly></el-input>
              </el-form-item>

              <el-form-item label="生年月日" prop="name">
                <el-date-picker prefix-icon="el-icon-info" v-model="empListForm.birthday" size="mini" type="date" style="margin-left:10px;width: 200px" placeholder="生年月日" readonly="readonly">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="世帯主の氏名" prop="name">
                <el-input v-model="ruleForm.host_name" size="mini" style="margin-left:10px;width: 200px"></el-input>
              </el-form-item>

              <el-form-item label="配偶者の有無" prop="spouse_is">
                <el-select v-model="ruleForm.spouse_is" style="margin-left: 10px; width: 200px" :placeholder="$t('general.select')" size="mini">
                  <el-option v-for="item in spouse" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <el-form-item label="記載例" prop="name">
                <el-link style="margin-left:10px;" type="primary" class="el-icon-info" :underline="false" href="https://www.nta.go.jp/taxes/tetsuzuki/shinsei/annai/gensen/pdf/r3bun_02.pdf" target="_blank">控除申告書の記載例はこちら</el-link>
              </el-form-item>

              <el-form-item :label="$t('empPDF.name_frgn')" prop="name_frgn">
                <el-input prefix-icon="el-icon-info" v-model="empListForm.name_frgn" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.name_frgn')" readonly></el-input>
              </el-form-item>

              <el-form-item label="個人番号" prop="name">
                <el-input prefix-icon="el-icon-info" v-model="empListForm.mynum" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
              </el-form-item>

              <el-form-item label="あなたとの続柄" prop="name">
                <el-input v-model="ruleForm.relation" size="mini" style="margin-left:10px;width: 185px"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div>
              <el-form-item :label="$t('empPDF.address')" prop="address">
                <el-input :value="empListForm.address" prefix-icon="el-icon-info" size="mini" style="margin-left:10px;width: 825px" :placeholder="$t('empPDF.address')" readonly></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addRaise('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}</el-button>
        <el-button style="width:120px" @click="raise_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!-- 給与所得者の扶養控除等（異動）申告 -->
    <el-dialog title="給与所得者の扶養控除等（異動）申告" :visible.sync="dialogRaiseDeclaration" width="94%" :before-close="handleClose">
      <div align="left" style="margin-top:20px;margin-bottom:39px;float:left;">
        &emsp;社員名:&emsp;{{name}}<br>&emsp;社員番号:&emsp;{{employee_id}}
      </div>
      <div align="right" style="margin-top:20px;margin-bottom:39px;margin-right:215px">
        <el-button class="el-icon-circle-plus-outline" type="primary" size="mini" @click="handleAdd()">新規
        </el-button>
      </div>

      <el-table v-loading="loading" :data="raiseDecData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">
        <el-table-column label="年分" align="center" width="100px">
          <template slot-scope="scope">
            <span>{{ scope.row.year }}</span>
          </template>
        </el-table-column>
        <el-table-column label="配偶者の有無" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.spouse_is }}</span>
          </template>
        </el-table-column>
        <el-table-column label="世帯主の氏名" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.host_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="あなたと世帯主の続柄" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.relation }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="500px;">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
              {{$t("general.edit")}}</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
              {{$t("general.delete")}}</el-button>
            <el-button size="mini" type="info" icon="el-icon-info" @click="handleFamily(scope.$index, scope.row)">
              撫養親族情報</el-button>
            <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
              {{$t("general.print")}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 撫養親族情報 -->
    <el-dialog title="撫養親族情報" :visible.sync="dialogFamily" width="86%" :before-close="handleClose">
      <div align="left" style="margin-top:20px;margin-bottom:39px;float:left;">
        &emsp;社員名:&emsp;{{name}}<br>&emsp;社員番号:&emsp;{{employee_id}}
      </div>
      <div align="right" style="margin-top:20px;margin-bottom:39px;margin-right:96px">
        <el-button class="el-icon-circle-plus-outline" type="primary" size="mini" @click="handleAddFamily()">撫養親族追加
        </el-button>
      </div>

      <el-table v-loading="loading" :data="familyData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">
        <el-table-column label="氏名" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.name_family }}</span>
          </template>
        </el-table-column>
        <el-table-column label="性別" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.gender }}</span>
          </template>
        </el-table-column>
        <el-table-column label="生年月日" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.birthday_family }}</span>
          </template>
        </el-table-column>
        <el-table-column label="従業員との続柄" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.relation }}</span>
          </template>
        </el-table-column>
        <el-table-column label="見積額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.income }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="300px;">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleUpdateFamily(scope.$index, scope.row)">
              {{$t("general.edit")}}</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleFamilyDelete(scope.$index, scope.row)">
              {{$t("general.delete")}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--add family-->
    <el-dialog title="撫養親族新規" :append-to-body="true" :visible.sync="dialogAddFamily" width="86%" :before-close="handleClose">
      <el-form :model="empFamilyForm" :rules="rules" ref="empFamilyForm" label-width="210px" class="demo-ruleForm" size="medium" style="margin-left:20px" :label-position="labelPosition">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="基本情報" name="1">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="氏名" prop="name_family">
                    <el-input v-model="empFamilyForm.name_family" size="mini" style="margin-left:10px;width: 185px" placeholder="入力してください" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="国籍・地域" prop="nation">
                    <el-select size="mini" style="margin-left: 10px; width: 185px" class="selectBg" placeholder="国選択" v-model="empFamilyForm.nation" filterable clearable>
                      <el-option-group class="groupBg" v-for="group in country" :key="group.label" :label="group.label">
                        <el-option :disabled="item.disabled" v-for="item in group.options" :key="item.value" :label="item.value" :value="item.value" type="button"></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="性別" prop="gender">
                    <el-radio-group v-model="empFamilyForm.gender" style="margin-left: 10px">
                      <el-radio :label="$t('empList.male')">{{
                        $t("empList.male")
                      }}</el-radio>
                      <el-radio style="margin-left: 50px" :label="$t('empList.female')">{{ $t("empList.female") }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item :label="$t('empList.relation')" prop="relation">
                    <el-select :placeholder="$t('general.select')" v-model="empFamilyForm.relation" style="margin-left: 10px; width: 185px" size="mini">
                      <el-option v-for="item in relations" :key="item.relationsId" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item label="氏名（フリガナ）" prop="name_frgn_family">
                    <el-input v-model="empFamilyForm.name_frgn_family" size="mini" style="margin-left:10px;width: 185px" placeholder="入力してください" clearable></el-input>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != true" :label="$t('empList.birthday')" prop="birthday_family">
                    <el-date-picker @change="DateInput11(empFamilyForm.birthday_family)" v-model="empFamilyForm.birthday_family" size="mini" value-format="yyyy-MM-dd" style="margin-left:10px;width:185px" placeholder="例:1996-3-20" type="date"></el-date-picker>
                    <span> {{ dateForm.DateInput11 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != false" :label="$t('empList.birthday')" prop="birthday_family">
                    <el-input prefix-icon="el-icon-edit" @change="DateInput12(empFamilyForm.birthday_family)" v-model="empFamilyForm.birthday_family" size="mini" style="margin-left:10px;width:185px" placeholder="例:H8/3/20" clearable=""></el-input>
                    <span> {{ dateForm.DateInput12 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item label="マイナンバー" prop="mynum_family">
                    <el-input v-model="empFamilyForm.mynum_family" size="mini" style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>

                  <el-form-item label="見積額" prop="income">
                    <el-input @change="empFamilyFormToMoney()" v-model="empFamilyForm.income" size="mini" style="margin-left:10px;width: 185px"></el-input>
                    &nbsp;円
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item label="住所" prop="address">
                    <el-input v-model="empFamilyForm.address" size="mini" style="margin-left:10px;width:810px"></el-input>
                    <el-checkbox @change="togetherChange()" v-model="empFamilyForm.together">同居</el-checkbox>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="控除申告情報" name="2">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="非居住者である" prop="non_resident_is">
                    <el-checkbox v-model="empFamilyForm.non_resident_is" style="margin-left:10px;"></el-checkbox>
                  </el-form-item>

                  <el-form-item label="源泉控除対象該当" prop="withholding_d_is">
                    <el-checkbox v-model="empFamilyForm.withholding_d_is" style="margin-left:10px;"></el-checkbox>
                  </el-form-item>

                  <el-form-item label="扶養区分" prop="raise_division">
                    <el-select v-model="empFamilyForm.raise_division" size="mini" placeholder="選択" style="margin-left:10px;width: 185px" clearable>
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item label="生計を一にする事実" prop="money_raise">
                    <el-input @change="empFamilyFormToMoney()" v-model="empFamilyForm.money_raise" size="mini" style="margin-left:10px;width: 185px"></el-input>
                    &nbsp;円
                    <el-popover placement="top-start" title="ヒント:" width="190" trigger="hover" content="「生計を一にする事実」欄に配偶者にその年に送金等をした金額の合計額を記入します。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item label="撫養控除対象対象外" prop="raise_d_not">
                    <el-checkbox v-model="empFamilyForm.raise_d_not" style="margin-left:10px;"></el-checkbox>
                  </el-form-item>

                  <el-form-item label="障害者区分" prop="disabled_division">
                    <el-select v-model="empFamilyForm.disabled_division" size="mini" placeholder="選択" style="margin-left:10px;width: 185px" clearable>
                      <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item label="異動月日及び事由" prop="cause">
                    <el-input v-model="empFamilyForm.cause" size="mini" style="margin-left:10px;width:810px"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item label="メモ" prop="memo">
                    <el-input v-model="empFamilyForm.memo" size="mini" style="margin-left:10px;width:810px"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addFamily('empFamilyForm')" type="primary" size="medium">
          {{$t("general.confirm")}}</el-button>
        <el-button style="width:120px" @click="family_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!--edit family-->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdateFamily" width="86%" :before-close="handleClose">
      <el-form :model="empFamilyForm" :rules="rules" ref="empFamilyForm" label-width="210px" class="demo-ruleForm" size="medium" style="margin-left:20px" :label-position="labelPosition">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="基本情報" name="1">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="氏名" prop="name_family">
                    <el-input v-model="empFamilyForm.name_family" size="mini" style="margin-left:10px;width: 185px" placeholder="入力してください" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="国籍・地域" prop="nation">
                    <el-select size="mini" style="margin-left: 10px; width: 185px" class="selectBg" placeholder="国選択" v-model="empFamilyForm.nation" filterable clearable>
                      <el-option-group class="groupBg" v-for="group in country" :key="group.label" :label="group.label">
                        <el-option :disabled="item.disabled" v-for="item in group.options" :key="item.value" :label="item.value" :value="item.value" type="button"></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="性別" prop="gender">
                    <el-radio-group v-model="empFamilyForm.gender" style="margin-left: 10px">
                      <el-radio :label="$t('empList.male')">{{
                        $t("empList.male")
                      }}</el-radio>
                      <el-radio style="margin-left: 50px" :label="$t('empList.female')">{{ $t("empList.female") }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item :label="$t('empList.relation')" prop="relation">
                    <el-select :placeholder="$t('general.select')" v-model="empFamilyForm.relation" style="margin-left: 10px; width: 185px" size="mini">
                      <el-option v-for="item in relations" :key="item.relationsId" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item label="氏名（フリガナ）" prop="name_frgn_family">
                    <el-input v-model="empFamilyForm.name_frgn_family" size="mini" style="margin-left:10px;width: 185px" placeholder="入力してください" clearable></el-input>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != true" :label="$t('empList.birthday')" prop="birthday_family">
                    <el-date-picker @change="DateInput11(empFamilyForm.birthday_family)" v-model="empFamilyForm.birthday_family" size="mini" value-format="yyyy-MM-dd" style="margin-left:10px;width:185px" placeholder="例:1996-3-20" type="date"></el-date-picker>
                    <span> {{ dateForm.DateInput11 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != false" :label="$t('empList.birthday')" prop="birthday_family">
                    <el-input prefix-icon="el-icon-edit" @change="DateInput12(empFamilyForm.birthday_family)" v-model="empFamilyForm.birthday_family" size="mini" style="margin-left:10px;width:185px" placeholder="例:H8/3/20" clearable=""></el-input>
                    <span> {{ dateForm.DateInput12 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item label="マイナンバー" prop="mynum_family">
                    <el-input v-model="empFamilyForm.mynum_family" size="mini" style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>

                  <el-form-item label="見積額" prop="income">
                    <el-input @change="empFamilyFormToMoney()" v-model="empFamilyForm.income" size="mini" style="margin-left:10px;width: 185px"></el-input>
                    &nbsp;円
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item label="住所" prop="address">
                    <el-input v-model="empFamilyForm.address" size="mini" style="margin-left:10px;width:810px"></el-input>
                    <el-checkbox @change="togetherChange()" v-model="empFamilyForm.together">同居</el-checkbox>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="控除申告情報" name="2">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="非居住者である" prop="non_resident_is">
                    <el-checkbox v-model="empFamilyForm.non_resident_is" style="margin-left:10px;"></el-checkbox>
                  </el-form-item>

                  <el-form-item label="源泉控除対象該当" prop="withholding_d_is">
                    <el-checkbox v-model="empFamilyForm.withholding_d_is" style="margin-left:10px;"></el-checkbox>
                  </el-form-item>

                  <el-form-item label="扶養区分" prop="raise_division">
                    <el-select v-model="empFamilyForm.raise_division" size="mini" placeholder="選択" style="margin-left:10px;width: 185px" clearable>
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item label="生計を一にする事実" prop="money_raise">
                    <el-input @change="empFamilyFormToMoney()" v-model="empFamilyForm.money_raise" size="mini" style="margin-left:10px;width: 185px"></el-input>
                    &nbsp;円
                    <el-popover placement="top-start" title="ヒント:" width="190" trigger="hover" content="「生計を一にする事実」欄に配偶者にその年に送金等をした金額の合計額を記入します。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item label="撫養控除対象対象外" prop="raise_d_not">
                    <el-checkbox v-model="empFamilyForm.raise_d_not" style="margin-left:10px;"></el-checkbox>
                  </el-form-item>

                  <el-form-item label="障害者区分" prop="disabled_division">
                    <el-select v-model="empFamilyForm.disabled_division" size="mini" placeholder="選択" style="margin-left:10px;width: 185px" clearable>
                      <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item label="異動月日及び事由" prop="cause">
                    <el-input v-model="empFamilyForm.cause" size="mini" style="margin-left:10px;width:810px"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item label="メモ" prop="memo">
                    <el-input v-model="empFamilyForm.memo" size="mini" style="margin-left:10px;width:810px"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateFamily('empFamilyForm')" type="primary" size="medium">
          {{$t("general.confirm")}}</el-button>
        <el-button style="width:120px" @click="family_cancel('empFamilyForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      labelPosition: "left",
      value: "",
      empListForm: {
        id: "",
        employee_id: "",
        name: "",
        name_frgn: "",
        birthday: "",
        mynum: "",
        address: "",
      },
      years: [{
        value: "令和2年分",
        label: '令和2年'
      },
      {
        value: "令和3年分",
        label: '令和3年'
      }
      ],
      spouse: [
        {
          label: "有 ",
          value: "有 ",
        },
        {
          label: "無",
          value: "無",
        },
      ],
      relations: [{
        relationsId: 1,
        name: this.$t("empList.wife"),
      },
      {
        relationsId: 2,
        name: this.$t("empList.husband"),
      },
      {
        relationsId: 3,
        name: this.$t("empList.mother"),
      },
      {
        relationsId: 4,
        name: this.$t("empList.father"),
      },
      {
        relationsId: 5,
        name: this.$t("empList.mother_in_law"),
      },
      {
        relationsId: 6,
        name: this.$t("empList.father_in_law"),
      },
      {
        relationsId: 7,
        name: this.$t("empList.eldest_son"),
      },
      {
        relationsId: 8,
        name: this.$t("empList.eldest_daughter"),
      },
      {
        relationsId: 9,
        name: this.$t("empList.second_son"),
      },
      {
        relationsId: 10,
        name: this.$t("empList.second_daughter"),
      },
      {
        relationsId: 11,
        name: this.$t("empList.elder_brother"),
      },
      {
        relationsId: 12,
        name: this.$t("empList.elder_sister"),
      },
      {
        relationsId: 13,
        name: this.$t("empList.younger_brother"),
      },
      {
        relationsId: 14,
        name: this.$t("empList.younger_sister"),
      },
      {
        relationsId: 15,
        name: this.$t("empList.grandfather"),
      },
      {
        relationsId: 16,
        name: this.$t("empList.grandmother"),
      },],
      options: [{
        value: '同居老親等',
        label: '同居老親等'
      }, {
        value: '特定扶養親族',
        label: '特定扶養親族'
      }, {
        value: 'その他',
        label: 'その他'
      }],
      options2: [{
        value: '障害者',
        label: '障害者'
      }, {
        value: '特別障害者',
        label: '特別障害者'
      }, {
        value: '同居特別障害者',
        label: '同居特別障害者'
      },],
      //存储撫養親族情報的对象
      empFamilyForm: {
        id: "",
        eid: "",
        name_family: "",
        name_frgn_family: "",
        nation: "",
        gender: "",
        relation: "",
        mynum_family: "",
        birthday_family: "",
        income: 0,
        together: false,
        address: "",
        money_raise: 0,
        non_resident_is: false,
        withholding_d_is: false,
        raise_d_not: false,
        raise_division: "",
        disabled_division: "",
        cause: "",
        memo: "",
        date: ""
      },
      //国家对象包含国家信息
      country: [
        {
          label: "Popular country",
          options: [
            { value: "日本", label: "Japan" },
          ]
        },
        {
          label: "All country",
          options: [
            { value: "アブハジア", label: "Abkhazia, Republic of" },
            { value: "アフガニスタン", label: "Afghanistan" },
            { value: "アルバニア", label: "Albania" },
            { value: "アルジェリア", label: "Algeria" },
            { value: "アンドラ", label: "Andorra" },
            { value: "アンゴラ", label: "Angola" },
            { value: "アンティグア・バーブーダ", label: "Antigua and Barbuda" },
            { value: "アルゼンチン", label: "Argentina" },
            { value: "アルメニア", label: "Armenia" },
            { value: "オーストラリア", label: "Australia" },
            { value: "オーストリア", label: "Austria" },
            { value: "アゼルバイジャン", label: "Azerbaijan" },
            { value: "バハマ", label: "Bahamas" },
            { value: "バーレーン", label: "Bahrain" },
            { value: "バングラデシュ", label: "Bangladesh" },
            { value: "バルバドス", label: "Barbados" },
            { value: "ベラルーシ", label: "Belarus" },
            { value: "ベルギー", label: "Belgium" },
            { value: "ベリーズ", label: "Belize" },
            { value: "ベナン", label: "Benin" },
            { value: "ブータン", label: "Bhutan" },
            { value: "ボリビア", label: "Bolivia, Plurinational State of" },
            { value: "ボスニア・ヘルツェゴビナ", label: "Bosnia and Herzegovina" },
            { value: "ボツワナ", label: "Botswana" },
            { value: "ブラジル", label: "Brazil" },
            { value: "ブルネイ", label: "Brunei Darussalam" },
            { value: "ブルガリア", label: "Bulgaria" },
            { value: "ブルキナファソ", label: "Burkina Faso" },
            { value: "ブルンジ", label: "Burundi" },
            { value: "カンボジア", label: "Cambodia" },
            { value: "カメルーン", label: "Cameroon" },
            { value: "カナダ", label: "Canada" },
            { value: "カーボベルデ", label: "Cape Verde" },
            { value: "中央アフリカ共和国", label: "Central African Republic" },
            { value: "チャド", label: "Chad" },
            { value: "チリ", label: "Chile" },
            { value: "中国", label: "China" },
            { value: "コロンビア", label: "Colombia" },
            { value: "コモロ", label: "Comoros" },
            { value: "コンゴ共和国", label: "Congo" },
            { value: "コンゴ民主共和国", label: "Congo, the Democratic Republic of the" },
            { value: "クック諸島", label: "Cook Islands" },
            { value: "コスタリカ", label: "Costa Rica" },
            { value: "コートジボワール", label: "Côte d'Ivoire" },
            { value: "クロアチア", label: "Croatia" },
            { value: "キューバ", label: "Cuba" },
            { value: "キプロス", label: "Cyprus" },
            { value: "チェコ", label: "Czechia" },
            { value: "デンマーク", label: "Denmark" },
            { value: "ジブチ", label: "Djibouti" },
            { value: "ドミニカ国", label: "Dominica" },
            { value: "ドミニカ共和国", label: "Dominican Republic" },
            { value: "エクアドル", label: "Ecuador" },
            { value: "エジプト", label: "Egypt" },
            { value: "エルサルバドル", label: "El Salvador" },
            { value: "赤道ギニア", label: "Equatorial Guinea" },
            { value: "エリトリア", label: "Eritrea" },
            { value: "エストニア", label: "Estonia" },
            { value: "エチオピア", label: "Ethiopia" },
            { value: "フィジー", label: "Fiji" },
            { value: "フィンランド", label: "Finland" },
            { value: "フランス", label: "France" },
            { value: "ガボン", label: "Gabon" },
            { value: "ガンビア", label: "Gambia" },
            { value: "ジョージア", label: "Georgia" },
            { value: "ドイツ", label: "Germany" },
            { value: "ガーナ", label: "Ghana" },
            { value: "ギリシャ", label: "Greece" },
            { value: "グレナダ", label: "Grenada" },
            { value: "グアテマラ", label: "Guatemala" },
            { value: "ギニア", label: "Guinea" },
            { value: "ギニアビサウ", label: "Guinea-Bissau" },
            { value: "ガイアナ", label: "Guyana" },
            { value: "ハイチ", label: "Haiti" },
            { value: "バチカン", label: "Holy See (Vatican City State)" },
            { value: "ホンジュラス", label: "Honduras" },
            { value: "ハンガリー", label: "Hungary" },
            { value: "アイスランド", label: "Iceland" },
            { value: "インド", label: "India" },
            { value: "インドネシア", label: "Indonesia" },
            { value: "イラン", label: "Iran, Islamic Republic of" },
            { value: "イラク", label: "Iraq" },
            { value: "アイルランド", label: "Ireland" },
            { value: "イスラエル", label: "Israel" },
            { value: "イタリア", label: "Italy" },
            { value: "ジャマイカ", label: "Jamaica" },
            { value: "日本", label: "Japan" },
            { value: "ヨルダン", label: "Jordan" },
            { value: "カザフスタン", label: "Kazakhstan" },
            { value: "ケニア", label: "Kenya" },
            { value: "キリバス", label: "Kiribati" },
            { value: "北朝鮮", label: "Korea, Democratic People's Republic of" },
            { value: "韓国", label: "Korea, Republic of" },
            { value: "コソボ", label: "Kosovo" },
            { value: "クウェート", label: "Kuwait" },
            { value: "キルギス", label: "Kyrgyzstan" },
            { value: "ラオス", label: "Lao People's Democratic Republic" },
            { value: "ラトビア", label: "Latvia" },
            { value: "レバノン", label: "Lebanon" },
            { value: "レソト", label: "Lesotho" },
            { value: "リベリア", label: "Liberia" },
            { value: "リビア", label: "Libya" },
            { value: "リヒテンシュタイン", label: "Liechtenstein" },
            { value: "リトアニア", label: "Lithuania" },
            { value: "ルクセンブルク", label: "Luxembourg" },
            { value: "マケドニア旧ユーゴスラビア共和国", label: "Macedonia, the former Yugoslav Republic" },
            { value: "マダガスカル", label: "Madagascar" },
            { value: "マラウイ", label: "Malawi" },
            { value: "マレーシア", label: "Malaysia" },
            { value: "モルディブ", label: "Maldives" },
            { value: "マリ", label: "Mali" },
            { value: "マルタ", label: "Malta" },
            { value: "マーシャル諸島", label: "Marshall Islands" },
            { value: "モーリタニア", label: "Mauritania" },
            { value: "モーリシャス", label: "Mauritius" },
            { value: "メキシコ", label: "Mexico" },
            { value: "ミクロネシア連邦", label: "Micronesia, Federated States of" },
            { value: "モルドバ", label: "Moldova, Republic of" },
            { value: "モナコ", label: "Monaco" },
            { value: "モンゴル", label: "Mongolia" },
            { value: "モンテネグロ", label: "Montenegro" },
            { value: "モロッコ", label: "Morocco" },
            { value: "モザンビーク", label: "Mozambique" },
            { value: "ミャンマー", label: "Myanmar" },
            { value: "ナゴルノ・カラバフ", label: "Nagorno Karabagh Republic" },
            { value: "ナミビア", label: "Namibia" },
            { value: "ナウル", label: "Nauru" },
            { value: "ネパール", label: "Nepal" },
            { value: "オランダ", label: "Netherlands" },
            { value: "ニュージーランド", label: "New Zealand" },
            { value: "ニカラグア", label: "Nicaragua" },
            { value: "ニジェール", label: "Niger" },
            { value: "ナイジェリア", label: "Nigeria" },
            { value: "ニウエ", label: "Niue" },
            { value: "北キプロス", label: "Northern Cyprus" },
            { value: "ノルウェー", label: "Norway" },
            { value: "オマーン", label: "Oman" },
            { value: "パキスタン", label: "Pakistan" },
            { value: "パラオ", label: "Palau" },
            { value: "パレスチナ", label: "Palestinian Territory, Occupied" },
            { value: "パナマ", label: "Panama" },
            { value: "パプアニューギニア", label: "Papua New Guinea" },
            { value: "パラグアイ", label: "Paraguay" },
            { value: "ペルー", label: "Peru" },
            { value: "フィリピン", label: "Philippines" },
            { value: "ポーランド", label: "Poland" },
            { value: "ポルトガル", label: "Portugal" },
            { value: "沿ドニエストル", label: "Pridnestrovian Moldavian Republic" },
            { value: "カタール", label: "Qatar" },
            { value: "ルーマニア", label: "Romania" },
            { value: "ロシア", label: "Russian Federation" },
            { value: "ルワンダ", label: "Rwanda" },
            { value: "セントクリストファー・ネイビス", label: "Saint Kitts and Nevis" },
            { value: "セントルシア", label: "Saint Lucia" },
            { value: "セントビンセントおよびグレナディーン諸島", label: "Saint Vincent and the Grenadines" },
            { value: "サモア", label: "Samoa" },
            { value: "サンマリノ", label: "San Marino" },
            { value: "サントメ・プリンシペ", label: "Sao Tome and Principe" },
            { value: "サウジアラビア", label: "Saudi Arabia" },
            { value: "セネガル", label: "Senegal" },
            { value: "セルビア", label: "Serbia" },
            { value: "セーシェル", label: "Seychelles" },
            { value: "シエラレオネ", label: "Sierra Leone" },
            { value: "シンガポール", label: "Singapore" },
            { value: "スロバキア", label: "Slovakia" },
            { value: "スロベニア", label: "Slovenia" },
            { value: "ソロモン諸島", label: "Solomon Islands" },
            { value: "ソマリア", label: "Somalia" },
            { value: "ソマリランド", label: "Somaliland, Republic of" },
            { value: "南アフリカ", label: "South Africa" },
            { value: "南オセチア", label: "South Ossetia" },
            { value: "南スーダン", label: "South Sudan" },
            { value: "スペイン", label: "Spain" },
            { value: "スリランカ", label: "Sri Lanka" },
            { value: "スーダン", label: "Sudan" },
            { value: "スリナム", label: "Suriname" },
            { value: "スワジランド", label: "Swaziland" },
            { value: "スウェーデン", label: "Sweden" },
            { value: "スイス", label: "Switzerland" },
            { value: "シリア", label: "Syrian Arab Republic" },
            { value: "台湾", label: "Taiwan, Province of China" },
            { value: "タジキスタン", label: "Tajikistan" },
            { value: "タンザニア", label: "Tanzania, United Republic of" },
            { value: "タイ", label: "Thailand" },
            { value: "東ティモール", label: "Timor-Leste" },
            { value: "トーゴ", label: "Togo" },
            { value: "トンガ", label: "Tonga" },
            { value: "トリニダード・トバゴ", label: "Trinidad and Tobago" },
            { value: "チュニジア", label: "Tunisia" },
            { value: "トルコ", label: "Turkey" },
            { value: "トルクメニスタン", label: "Turkmenistan" },
            { value: "ツバル", label: "Tuvalu" },
            { value: "ウガンダ", label: "Uganda" },
            { value: "ウクライナ", label: "Ukraine" },
            { value: "アラブ首長国連邦", label: "United Arab Emirates" },
            { value: "イギリス", label: "United Kingdom" },
            { value: "アメリカ", label: "United States" },
            { value: "ウルグアイ", label: "Uruguay" },
            { value: "ウズベキスタン", label: "Uzbekistan" },
            { value: "バヌアツ", label: "Vanuatu" },
            { value: "ベネズエラ", label: "Venezuela, Bolivarian Republic of" },
            { value: "ベトナム", label: "Viet Nam" },
            { value: "西サハラ", label: "Western Sahara" },
            { value: "イエメン", label: "Yemen" },
            { value: "ザンビア", label: "Zambia" },
            { value: "ジンバブエ", label: "Zimbabwe" },
          ]
        }
      ],
      //处理和历相关定义的data
      dateForm: {
        JPDateType: false,
        JPDate: "",
        DateInput11: "",
        DateInput12: "",
        DateInput21: "",
        DateInput22: "",
      },
      ruleForm: {
        eid: "",
        year: "",
        spouse_is: "",
        host_name: "",
        relation: "",
        division_self: "",
        disable_division_self: "",
        memo: "",
      },
      rules: {
        name_family: [{
          required: true,
          message: this.$t("empList.nameRule"),
        },
        {
          pattern: /^[^\\x00-\\xff|\\uff61-\\uff9f|A-Za-z0-9)]+$/,
          message: this.$t("全角で入力してください"),
        },],
        birthday_family: [{
          required: true,
          message: this.$t("empList.birthdayP"),
          trigger: "blur",
        },],
        gender: [{
          required: true,
          message: this.$t("empList.gender_rule"),
          trigger: "blur",
        },],
      },
      activeNames: ['1', '2'],
      familyData: [],
      tableData: [],
      raiseDecData: [],
      dialogAdd: false,
      dialogEdit: false,
      dialogFamily: false,
      dialogUpdateFamily: false,
      dialogAddFamily: false,
      dialogVisible: false,
      dialogUpdate: false,
      dialogRaiseDeclaration: false,
      pageSize: 6,
      currentPage: 1,
      total: 0,
      disablePage: false,
      loading: false,
      sortName: "",
      sortOrder: "",
      eid: "",
      employee_id: "",
      name: ""
    };
  },
  methods: {
    //查询员工基本信息
    selectEmp() {
      let postData = this.qs.stringify({
        employee_id: this.employee_id,
      });
      this.axios({
        method: "post",
        url: "/ListEmpList",
        data: postData,
      })
        .then((response) => {
          this.ruleForm.eid = response.data[0].id;
          this.empListForm.name = response.data[0].name;
          this.empListForm.name_frgn = response.data[0].name_frgn;
          this.empListForm.birthday = response.data[0].birthday;
          this.empListForm.mynum = response.data[0].mynum;
          this.empListForm.address = response.data[0].address1 + response.data[0].address2 + response.data[0].address3;

        })
        .catch((error) => {
          console.log(error);
        });
    },
    jump(path) {
      this.$router.push(path);
    },
    //首页点击給与所得者の扶養控除等（異動）申告按钮
    handleRaiseDeclaration(index, row) {
      this.dialogRaiseDeclaration = true;
      this.eid = row.id;
      this.employee_id = row.employee_id;
      this.name = row.name;
      this.handleCurrentChange();
    },
    //撫養親族情報页面点击追加按钮
    handleAddFamily() {
      this.dialogAddFamily = true;
    },
    handleUpdateFamily(index, row) {
      this.dialogUpdateFamily = true;
      //返回对象属性比ruleForm少时，需要assign方法中间加ruleForm参数。不然vue监听不到缺少的ruleForm属性。
      this.empFamilyForm = Object.assign({}, row);
      this.empFamilyForm.money_raise = Number(this.empFamilyForm.money_raise).toLocaleString();
    },
    handleFamilyDelete(index, row) {
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id,
          });
          this.axios({
            method: "post",
            url: "/deleteFamily",
            data: postData,
          })
            .then((response) => {
              var result = response.data;
              if (result != 0) {
                this.handleFamily();
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed"),
                });
              } else {
                this.$message({
                  type: "warning",
                  message: "エラーが発生しました",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled"),
          });
        });

    },
    //点击进入撫養親族情報页面
    handleFamily() {
      this.dialogFamily = true;
      let postData = this.qs.stringify({
        eid: this.eid,
      });
      this.axios({
        method: "post",
        url: "/pageFamily",
        data: postData,
      })
        .then((response) => {
          for (var i = 0; i < response.data.length; i++) {
            response.data[i].income = Number(response.data[i].income).toLocaleString();
          }
          this.familyData = response.data;
        })
        .catch((error) => {
        });
    },
    //給与所得者の扶養控除等（異動）申告页面编辑
    handleEdit(index, row) {
      this.ruleForm = Object.assign({}, row);
      this.dialogEdit = true;
      this.selectEmp();
    },
    handleAdd() {
      this.dialogAdd = true;
      this.selectEmp();
    },
    addRaise(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            eid: this.ruleForm.eid,
            year: this.ruleForm.year,
            spouse_is: this.ruleForm.spouse_is,
            host_name: this.ruleForm.host_name,
            relation: this.ruleForm.relation,
            division_self: this.ruleForm.division_self,
            disable_division_self: this.ruleForm.disable_division_self,
          });
          this.axios({
            method: "post",
            url: "/insertRaiseDeclaration",
            data: postData,
          })
            .then((response) => {
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed"),
              });
              this.raise_cancel();
              this.handleCurrentChange();
            })
            .catch((error) => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed"),
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message.error('必須項目が入力されていません');
          return false;
        }
      });
    },
    updateRaise(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.ruleForm.id,
            eid: this.ruleForm.eid,
            year: this.ruleForm.year,
            spouse_is: this.ruleForm.spouse_is,
            host_name: this.ruleForm.host_name,
            relation: this.ruleForm.relation,
            division_self: this.ruleForm.division_self,
            disable_division_self: this.ruleForm.disable_division_self,
          });
          this.axios({
            method: "post",
            url: "/updateRaiseDeclaration",
            data: postData,
          })
            .then((response) => {
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed"),
              });
              this.raise_cancel();
              this.handleCurrentChange();
            })
            .catch((error) => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed"),
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message.error('必須項目が入力されていません');
          return false;
        }
      });
    },
    raise_cancel() {
      this.dialogEdit = false;
      this.dialogAdd = false;
      this.ruleForm = {
        eid: "",
        year: "",
        spouse_is: "",
        host_name: "",
        relation: "",
        division_self: "",
        disable_division_self: "",
        memo: "",
      }
    },
    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then((_) => {
          this.emptyUserData();
          done();
        })
        .catch((_) => { });
    },
    handleDelete(index, row) {
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id,
          });
          this.axios({
            method: "post",
            url: "/deleteRaiseDeclaration",
            data: postData,
          })
            .then((response) => {
              var result = response.data;
              if (result != 0) {
                this.handleCurrentChange();
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed"),
                });
              } else {
                this.$message({
                  type: "warning",
                  message: "エラーが発生しました",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled"),
          });
        });
    },
    //点击table表格的排序箭头
    changeTableSort(column) {
      this.sortName = column.prop;
      this.sortOrder = column.order;
      let postData = this.qs.stringify({
        sortName: this.sortName,
        sortOrder: this.sortOrder,
        page: this.currentPage
      });
      this.axios({
        method: "post",
        url: "/changeTableSort",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
      localStorage.setItem("sortNameSalaryMain", JSON.stringify(this.sortName));
      localStorage.setItem("sortOrderSalaryMain", JSON.stringify(this.sortOrder));
    },
    //点击分页页码
    handleSortChange(column) {
      this.sortName = column.prop;
      this.sortOrder = column.order;
      let postData = this.qs.stringify({
        sortName: JSON.parse(localStorage.getItem("sortNameSalaryMain")),
        sortOrder: JSON.parse(localStorage.getItem("sortOrderSalaryMain")),
        page: this.currentPage
      });
      this.axios({
        method: "post",
        url: "/changeTableSort",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleCurrentChange() {
      let postData = this.qs.stringify({
        eid: this.eid
      });
      this.axios({
        method: "post",
        url: "/pageRaiseDeclaration",
        data: postData,
      })
        .then((response) => {
          this.raiseDecData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //点击同居与否时触发的方法
    togetherChange() {
      if (this.empFamilyForm.together === true) {
        let postData = this.qs.stringify({
          employee_id: this.employee_id,
        });
        this.axios({
          method: "post",
          url: "/selectEmplistByEidAndUid",
          data: postData,
        })
          .then((response) => {
            this.empFamilyForm.address = response.data.address1 + response.data.address2 + response.data.address3;
          })
          .catch((error) => {
          });
      } else {
        this.empFamilyForm.address = "";
      }
    },
    family_cancel(empFamilyForm) {
      this.dialogAddFamily = false;
      this.dialogUpdateFamily = false;
      this.$refs[empFamilyForm].resetFields();
      this.emptyUserData();

    },
    //全部数据清空，dialog关闭
    s1_cancel(ruleForm) {
      this.dialogFamily = false;
      this.dialogUpdateFamily = false;
      this.dialogAddFamily = false;
      this.dialogVisible = false;
      this.dialogUpdate = false;
      this.dialogRaiseDeclaration = false;
      this.emptyUserData();
      this.$refs[ruleForm].resetFields();
    },
    cancel() {
      this.dialogUpdate = false;
      this.dialogVisible = false;
      this.emptyUserData();
    },
    //处理和历的生日相关方法
    DateInput11(val) {
      this.JPDate(val);
      this.dateForm.DateInput11 = this.dateForm.JPDate;
    },
    DateInput12(val) {
      this.JPDateToEn(val);
      this.dateForm.DateInput12 = this.dateForm.JPDate;
    },
    JPDateToEn(val) {
      if (val === "") {
        this.dateForm.JPDate = "";
      }
      if (val.indexOf("/") != -1) {
        var tempDate = val.split("/");

        var JPYear = tempDate[0].substring(0, 1);
        var JPYearNum = tempDate[0].substring(1);
        var JPMonthNum = tempDate[1];
        var JPDayNum = tempDate[2];

        switch (JPYear) {
          case "S":
            JPYearNum = Number(JPYearNum) + 1925;
            JPMonthNum < 10 ? JPMonthNum = "0" + JPMonthNum : JPMonthNum;
            JPDayNum < 10 ? JPDayNum = "0" + JPDayNum : JPDayNum;
            break;
          case "H":
            JPYearNum = Number(JPYearNum) + 1988;
            JPMonthNum < 10 ? JPMonthNum = "0" + JPMonthNum : JPMonthNum;
            JPDayNum < 10 ? JPDayNum = "0" + JPDayNum : JPDayNum;
            break;
          case "R":
            JPYearNum = Number(JPYearNum) + 2018;
            JPMonthNum < 10 ? JPMonthNum = "0" + JPMonthNum : JPMonthNum;
            JPDayNum < 10 ? JPDayNum = "0" + JPDayNum : JPDayNum;
            break;
        }
        this.dateForm.JPDate = JPYearNum + "-" + JPMonthNum + "-" + JPDayNum;
      }
    },
    JPDate(val) {
      var date = new Date(val);
      var JPDate = new Intl.DateTimeFormat('ja-JP-u-ca-japanese').format(date);
      this.dateForm.JPDate = JPDate;
      if (val === null) {
        this.dateForm.JPDate = "";
      }

    },
    //清空Form中当前数据
    emptyUserData() {
      this.empFamilyForm = {
        id: "",
        eid: "",
        name_family: "",
        name_frgn_family: "",
        nation: "",
        gender: "",
        relation: "",
        mynum_family: "",
        birthday_family: "",
        income: 0,
        together: false,
        address: "",
        money_raise: 0,
        non_resident_is: false,
        withholding_d_is: false,
        raise_d_not: false,
        raise_division: "",
        disabled_division: "",
        cause: "",
        memo: "",
        date: ""
      },
        this.ruleForm = {
          id: "",
          eid: "",
          year: "",
          income_year_basic: 0,
          income_after_basic: 0,
          income_outside_after_basic: 0,
          total_basic: 0,
          judgement_basic: "",
          division1: "",
          basic_d_amount: 0,
          income_year_spouse: 0,
          income_after_spouse: 0,
          income_outside_after_spouse: 0,
          total_spouse: 0,
          judgement_spouse: "",
          division2: "",
          declaration_spouse: 0,
          declaration_special_spouse: 0,
          requirement: "",
          requirement_is: "無",
          description: "",
        };
    },
    empFamilyFormToMoney() {
      if (this.empFamilyForm.income != null && this.empFamilyForm.income != "") {
        if (this.empFamilyForm.income.indexOf(",") != -1) {
          this.empFamilyForm.income = String(this.empFamilyForm.income);
          this.empFamilyForm.income = Number(this.empFamilyForm.income.split(",").join(""));
        }
        this.empFamilyForm.income = Number(this.empFamilyForm.income).toLocaleString();
      }

      if (this.empFamilyForm.money_raise != null && this.empFamilyForm.money_raise != "") {
        if (this.empFamilyForm.money_raise.indexOf(",") != -1) {
          this.empFamilyForm.money_raise = String(this.empFamilyForm.money_raise);
          this.empFamilyForm.money_raise = Number(this.empFamilyForm.money_raise.split(",").join(""));
        }
        this.empFamilyForm.money_raise = Number(this.empFamilyForm.money_raise).toLocaleString();
      }
    },
    //撫養親族追加
    addFamily(empFamilyForm) {
      this.empFamilyForm.income = Number(this.empFamilyForm.income.split(",").join(""));
      this.empFamilyForm.money_raise = Number(this.empFamilyForm.money_raise.split(",").join(""));
      if (this.empFamilyForm.birthday_family != null && this.empFamilyForm.birthday_family != "") {
        if (this.empFamilyForm.birthday_family.indexOf("/") != -1) {
          this.empFamilyForm.birthday_family = this.dateForm.JPDate;
        }
      }
      this.$refs[empFamilyForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            eid: this.eid,
            name_family: this.empFamilyForm.name_family,
            name_frgn_family: this.empFamilyForm.name_frgn_family,
            nation: this.empFamilyForm.nation,
            gender: this.empFamilyForm.gender,
            relation: this.empFamilyForm.relation,
            mynum_family: this.empFamilyForm.mynum_family,
            birthday_family: this.empFamilyForm.birthday_family,
            income: this.empFamilyForm.income,
            together: this.empFamilyForm.together,
            address: this.empFamilyForm.address,
            money_raise: this.empFamilyForm.money_raise,
            non_resident_is: this.empFamilyForm.non_resident_is,
            withholding_d_is: this.empFamilyForm.withholding_d_is,
            raise_d_not: this.empFamilyForm.raise_d_not,
            raise_division: this.empFamilyForm.raise_division,
            disabled_division: this.empFamilyForm.disabled_division,
            cause: this.empFamilyForm.cause,
            memo: this.empFamilyForm.memo,
          });
          this.axios({
            method: "post",
            url: "/insertFamily",
            data: postData,
          })
            .then((response) => {
              if (response.data > 0) {
                this.handleFamily();
                this.$message({
                  type: "success",
                  message: this.$t("general.add_completed"),
                });
                this.emptyUserData();
                this.dialogAddFamily = false;
              } else {
                this.$message({
                  type: "warning",
                  message: this.$t("general.add_failed"),
                });
              }
            })
            .catch((error) => {
              this.$message({
                type: "warning",
                message: this.$t("general.add_failed"),
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message.error('必須項目が入力されていません');
          return false;
        }
      });
    },
    updateFamily(empFamilyForm) {
      this.empFamilyForm.income = Number(this.empFamilyForm.income.split(",").join(""));
      this.empFamilyForm.money_raise = Number(this.empFamilyForm.money_raise.split(",").join(""));
      if (this.empFamilyForm.birthday_family != null && this.empFamilyForm.birthday_family != "") {
        if (this.empFamilyForm.birthday_family.indexOf("/") != -1) {
          this.empFamilyForm.birthday_family = this.dateForm.JPDate;
        }
      }
      this.$refs[empFamilyForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.empFamilyForm.id,
            eid: this.eid,
            name_family: this.empFamilyForm.name_family,
            name_frgn_family: this.empFamilyForm.name_frgn_family,
            nation: this.empFamilyForm.nation,
            gender: this.empFamilyForm.gender,
            relation: this.empFamilyForm.relation,
            mynum_family: this.empFamilyForm.mynum_family,
            birthday_family: this.empFamilyForm.birthday_family,
            income: this.empFamilyForm.income,
            together: this.empFamilyForm.together,
            address: this.empFamilyForm.address,
            money_raise: this.empFamilyForm.money_raise,
            non_resident_is: this.empFamilyForm.non_resident_is,
            withholding_d_is: this.empFamilyForm.withholding_d_is,
            raise_d_not: this.empFamilyForm.raise_d_not,
            raise_division: this.empFamilyForm.raise_division,
            disabled_division: this.empFamilyForm.disabled_division,
            cause: this.empFamilyForm.cause,
            memo: this.empFamilyForm.memo
          });
          this.axios({
            method: "post",
            url: "/updateFamily",
            data: postData,
          })
            .then((response) => {
              if (response.data > 0) {
                this.handleFamily();
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed"),
                });
                this.emptyUserData();
                this.dialogUpdateFamily = false;
              } else {
                this.$message({
                  type: "warning",
                  message: this.$t("general.edit_failed"),
                });
              }
            })
            .catch((error) => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed"),
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message.error('必須項目が入力されていません');
          return false;
        }
      });
    },
    addUser(ruleForm) {
      this.handleToNumber();
      this.ruleForm.income_year_basic = Number(this.ruleForm.income_year_basic.split(",").join(""));
      this.ruleForm.income_year_spouse = Number(this.ruleForm.income_year_spouse.split(",").join(""));
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            eid: this.eid,
            year: this.ruleForm.year,
            income_year_basic: this.ruleForm.income_year_basic,
            income_after_basic: this.ruleForm.income_after_basic,
            income_outside_after_basic: this.ruleForm.income_outside_after_basic,
            total_basic: this.ruleForm.total_basic,
            judgement_basic: this.ruleForm.judgement_basic,
            division1: this.ruleForm.division1,
            basic_d_amount: this.ruleForm.basic_d_amount,
            income_year_spouse: this.ruleForm.income_year_spouse,
            income_after_spouse: this.ruleForm.income_after_spouse,
            income_outside_after_spouse: this.ruleForm.income_outside_after_spouse,
            total_spouse: this.ruleForm.total_spouse,
            judgement_spouse: this.ruleForm.judgement_spouse,
            division2: this.ruleForm.division2,
            declaration_spouse: this.ruleForm.declaration_spouse,
            declaration_special_spouse: this.ruleForm.declaration_special_spouse,
            requirement: this.ruleForm.requirement,
            // requirement_is: this.ruleForm.requirement_is,
            description: this.ruleForm.description,
          });
          this.axios({
            method: "post",
            url: "/insertBasicDeclaration",
            data: postData,
          })
            .then((response) => {
              var result = response.data;
              if (result > 0) {
                this.handleCurrentChange();
                this.$message({
                  type: "success",
                  message: this.$t("general.add_completed"),
                });
                this.dialogVisible = false;
              } else {
                this.$message({
                  type: "warning",
                  message: this.$t("general.add_failed"),
                });
              }
            })
            .catch((error) => {
              this.$message({
                type: "warning",
                message: this.$t("general.add_failed"),
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message.error('必須項目が入力されていません');
          return false;
        }
      });
    },
    updateUser(ruleForm) {
      this.handleToNumber();
      this.ruleForm.income_year_basic = Number(this.ruleForm.income_year_basic.split(",").join(""));
      this.ruleForm.income_year_spouse = Number(this.ruleForm.income_year_spouse.split(",").join(""));
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.ruleForm.id,
            eid: this.eid,
            year: this.ruleForm.year,
            income_year_basic: this.ruleForm.income_year_basic,
            income_after_basic: this.ruleForm.income_after_basic,
            income_outside_after_basic: this.ruleForm.income_outside_after_basic,
            total_basic: this.ruleForm.total_basic,
            judgement_basic: this.ruleForm.judgement_basic,
            division1: this.ruleForm.division1,
            basic_d_amount: this.ruleForm.basic_d_amount,
            income_year_spouse: this.ruleForm.income_year_spouse,
            income_after_spouse: this.ruleForm.income_after_spouse,
            income_outside_after_spouse: this.ruleForm.income_outside_after_spouse,
            total_spouse: this.ruleForm.total_spouse,
            judgement_spouse: this.ruleForm.judgement_spouse,
            division2: this.ruleForm.division2,
            declaration_spouse: this.ruleForm.declaration_spouse,
            declaration_special_spouse: this.ruleForm.declaration_special_spouse,
            requirement: this.ruleForm.requirement,
            description: this.ruleForm.description
          });
          this.axios({
            method: "post",
            url: "/updateBasicDeclaration",
            data: postData,
          })
            .then((response) => {
              var result = response.data;
              if (result > 0) {
                this.handleCurrentChange();
                this.s1_cancel(ruleForm);
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed"),
                });
                this.dialogUpdate = false;
              }
            })
            .catch((error) => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed"),
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message.error('必須項目が入力されていません');
          return false;
        }
      });
    },
  },
  created() {
    this.axios
      .post("/pageEmpList")
      .then((response) => {

        this.tableData = response.data;
      })
      .catch((error) => {
      });
    this.axios
      .post("/rowsEmpList")
      .then((response) => {
        this.total = response.data;
      })
      .catch((error) => {
      });
  },
};
</script>

<style>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
  width: 90px;
}

.btn-custom-confirm {
  width: 90px;
}
</style>
<style scoped>
.search_name {
  width: 200px;
}

.pages {
  margin: 0px;
  padding: 0px;
  text-align: right;
}

.style1 {
  margin-right: 130px;
  padding: 0px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/EndYearAdj/RaiseDeclaration.vue